function restoreFilters() {
  const urlParams = new URLSearchParams(window.location.search);
  const facetInputs = document.querySelectorAll(".qld__search__facet-input");

  // Retrieve the ‘query’ parameter from the URL
  const query = urlParams.get("query");

  // Show or hide the query information based on the presence of the query
  const queryElement = document.querySelector(".qld__search__info-query");
  if (query && queryElement) {
    queryElement.style.display = "block";

    const searchInput = document.getElementById("search-input-resources-query");
    if (searchInput) {
      searchInput.disabled = false;
    }
  }

  // Restore date picker values
  const dateStartInput = document.querySelector(
    ".qld__date-picker-one duet-date-picker",
  );
  const dateEndInput = document.querySelector(
    ".qld__date-picker-two duet-date-picker",
  );
  const dateStartValue = urlParams.get("meta_d3") || null;
  const dateEndValue = urlParams.get("meta_d4") || null;

  if (dateStartInput) {
    dateStartInput.value = convertDateFormat(dateStartValue);
  }
  if (dateEndInput) {
    dateEndInput.value = convertDateFormat(dateEndValue);
  }

  // Create Date Range filter if present in URL
  if (dateStartValue || dateEndValue) {
    createDateRangeFilter(dateStartValue, dateEndValue);
  }

  // Loop through each facet input and restore checked state based on URL parameters
  facetInputs.forEach((input) => {
    const queryKey = input.dataset.querystring; // The key for the input
    const [InputKey, InputValue] = queryKey.split("="); // Split to get key and value part
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);

    // Normalize InputKey
    const normalizedInputKey = decodeURIComponent(InputKey.replace(/\+/g, " "));
    const normalizedInputValue = decodeURIComponent(
      InputValue.replace(/\+/g, " "),
    );

    // Get all values associated with normalized InputKey and remove duplicates manually
    const allValues = urlParams
      .getAll(normalizedInputKey)
      .map((value) => value.replace(/\+/g, " "));
    const urlValueArray = [];

    allValues.forEach((value) => {
      if (!urlValueArray.includes(value)) {
        urlValueArray.push(value); // Add only if not already in the array
      }
    });

    // Check if the InputValue is present in the URL values
    if (
      normalizedInputValue &&
      urlValueArray.includes(normalizedInputValue.replace(/\+_/g, " _"))
    ) {
      input.checked = true; // Set the checkbox as checked
    } else {
      input.checked = false; // Set the checkbox as unchecked
    }
  });
}

function createDateRangeFilter(startDate, endDate) {
  let filterContainer = document.querySelector(".qld__search__filters");
  if (!filterContainer) {
    filterContainer = document.createElement("div");
    filterContainer.classList.add(
      "qld__search__filters",
      "qld__tag-list--wrapper",
    );
    filterContainer.innerHTML = `
            <span class="qld__tag-list--title">Filtered by:</span>
            <ul class="qld__search__filters-list qld__tag-list"></ul>
        `;
    const searchInfo = document.querySelector(".qld__search__info");
    if (searchInfo) {
      searchInfo.insertAdjacentElement("afterend", filterContainer);
    }
  }

  const filterList = filterContainer.querySelector(
    ".qld__search__filters-list",
  );

  // Create the date range filter element
  const li = document.createElement("li");
  li.innerHTML = `
        <div class="qld__tag qld__tag--filter">
            <span class="qld__tag--filter--text">${startDate ? formatDateForDisplay(startDate) : ""} - ${endDate ? formatDateForDisplay(endDate) : ""}</span>
            <button class="qld__tag--filter-close date-range-close" data-startdate="${startDate}" data-enddate="${endDate}">
                <svg class="qld__icon qld__icon--sm" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><use href="./?a=169317:dist/mysource_files/img/QLD-icons.svg#close"></use></svg>
                <span class="sr-only">Remove date range filter</span>
            </button>
        </div>
    `;

  // Check if the "Clear filters" button exists before calling `.closest('li')`
  const clearFilterElement = filterList.querySelector(
    ".qld__btn.qld__btn--tertiary",
  );
  const clearFiltersBtn = clearFilterElement
    ? clearFilterElement.closest("li")
    : null;

  // Insert the date range filter before the "Clear filters" button
  if (clearFiltersBtn) {
    filterList.insertBefore(li, clearFiltersBtn);
  } else {
    filterList.appendChild(li);
  }

  // Attach event listener for the close button
  li.querySelector(".qld__tag--filter-close").addEventListener(
    "click",
    handleFilterClose,
  );
}

function handleFilterClose(event) {
  const button = event.currentTarget;
  console.log("button", button);

  // Check if the button is for the date range filter
  if (button.classList.contains("date-range-close")) {
    const startDate = button.getAttribute("data-startdate");
    console.log("startDate", startDate);
    const endDate = button.getAttribute("data-enddate");
    console.log("endDate", endDate);

    // Remove date range filter from the URL
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    console.log("searchParams BEFORE", searchParams);
    // Delete each date parameter separately
    searchParams.delete("meta_d3");
    searchParams.delete("meta_d4");
    console.log("searchParams AFTER", searchParams);

    // Update the URL in the address bar without reloading the page
    window.history.replaceState(
      null,
      "",
      `${url.pathname}?${searchParams.toString()}`,
    );

    // Refresh the filters on the page if necessary
    restoreFilters();

    // Reload the page to reflect the new filters
    window.location.reload();
  } else {
    // For non-date-range filters
    const queryString = button.getAttribute("data-querystring");
    const [encodedFilterKey, encodedFilterValue] = queryString.split("=");

    const filterKey = decodeURIComponent(encodedFilterKey.replace(/\+/g, " "));
    const filterValue = decodeURIComponent(
      encodedFilterValue.replace(/\+/g, " "),
    );

    console.log("Filter Key:", filterKey);
    console.log("Filter Value:", filterValue);

    const facetInputs = document.querySelectorAll(".qld__search__facet-input");
    facetInputs.forEach((input) => {
      const [inputKey, inputValue] = input.dataset.querystring
        .split("=")
        .map((part) => decodeURIComponent(part.replace(/\+/g, " ")));

      if (inputKey === filterKey && inputValue === filterValue) {
        input.checked = false;
      }
    });

    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    const values = searchParams
      .getAll(filterKey)
      .filter((value) => value !== filterValue);
    searchParams.delete(filterKey);
    values.forEach((value) => searchParams.append(filterKey, value));

    window.history.replaceState(
      null,
      "",
      `${url.pathname}?${searchParams.toString()}`,
    );
    restoreFilters();
    window.location.reload();
  }
}

// Function to convert date format from dd/mm/yyyy to YYYY-MM-DD
function convertDateFormat(dateString) {
  if (!dateString) return "";

  const day = dateString.slice(0, 2);
  const monthStr = dateString.slice(2, 5);
  const year = dateString.slice(5);

  const monthMap = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  };
  const month = monthMap[monthStr] || "";

  return `${year}-${month}-${day}`;
}

// Function to format date
function formatDateToMeta(dateString) {
  const dateObj = new Date(dateString);
  const day = String(dateObj.getDate()).padStart(2, "0");
  const monthShort = dateObj.toLocaleString("en-US", { month: "short" });
  const year = dateObj.getFullYear();

  return `${day}${monthShort}${year}`;
}

// Function to convert date format from YYYY-MM-DD to Day Month Year
function formatDateForDisplay(dateString) {
  if (!dateString) return "";

  const day = dateString.slice(0, 2);
  const monthStr = dateString.slice(2, 5);
  const year = dateString.slice(5);

  return `${day} ${monthStr} ${year}`;
}

export function applyFilters(filterArray) {
  console.log("filterArray_______>", filterArray, "CHECKED FACETS ____>");
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);

  if (filterArray.length === 0) {
    // Remove query parameters from the URL
    window.history.replaceState(null, "", url.pathname);
    // Reload the page without query parameters
    window.location.reload();
    return;
  }

  // Remove filters that are no longer checked (i.e., not in filterArray)
  searchParams.forEach((value, key) => {
    // We need to check if the filter (key=value) is not in filterArray
    // filterArray is an array of objects like [{key: 'f.Audience|audience', value: 'health+professionals'}, ...]

    // ** Preserve the original search term **
    if (key === "query") return;
    // **

    // Check if the key exists in filterArray
    const filterInArray = filterArray.find(
      (filter) => filter.key === key && filter.value === value,
    );

    // If it's not found in the filterArray, remove it from the searchParams
    if (!filterInArray) {
      searchParams.delete(key);
    }
  });

  window.history.replaceState(
    null,
    "",
    `${url.pathname}?${searchParams.toString()}`,
  );

  filterArray.forEach((filter) => {
    const key = filter.key;
    let value = filter.value;

    if (key && value) {
      const decodedValue = decodeURIComponent(value);
      // Decode key for consistent comparison
      const decodedKey = decodeURIComponent(key);
      // Fetch existing values and normalize their encoding to spaces for consistency
      const existingValues = searchParams
        .getAll(decodedKey.replace(/\+/g, " "))
        .map((val) => val.replace(/\+/g, " "));

      // Additional logging to track each step
      console.log(
        "Processing Key:",
        key,
        "Decoded Key:",
        decodedKey,
        "Value:",
        value,
        "DECValue:",
        decodedValue,
        "Existing Values",
        existingValues,
      );

      // Append only if the normalized value is not already present
      if (!existingValues.includes(decodedValue.replace(/\+/g, " "))) {
        searchParams.append(decodedKey, decodedValue);
        console.log(`Appended: ${decodedKey} = ${decodedValue}`);
      }
    }
  });

  console.log("searchParams ----> ", [...searchParams]);

  // Handle individual date start and end filters if present
  const dateStartFilter = filterArray.find((filter) => filter.dateStart);
  const dateEndFilter = filterArray.find((filter) => filter.dateEnd);

  if (dateStartFilter && dateStartFilter.dateStart) {
    const formattedStartDate = formatDateToMeta(dateStartFilter.dateStart);
    searchParams.set("meta_d3", formattedStartDate);
  }

  if (dateEndFilter && dateEndFilter.dateEnd) {
    const formattedEndDate = formatDateToMeta(dateEndFilter.dateEnd);
    searchParams.set("meta_d4", formattedEndDate);
  }

  // Replace `%2B` with `+` in the final URL string to meet the exact format
  window.location.search = searchParams
    .toString()
    .replace(/%2B/g, "+")
    .replace(/\+_/g, "%2B_")
    .replace(/%257C/g, "%7C");
}

export function getFilterObject(facetParent) {
  const filters = [];
  const inputs = facetParent.querySelectorAll(".qld__search__facet-input");

  inputs.forEach((input) => {
    const queryParam = input.dataset.querystring.split("=");
    const filterQuery = queryParam[0];
    const filterValue = queryParam[1];
    if (input.checked && filterValue) {
      // Ensure value is present
      filters.push({
        key: filterQuery,
        value: filterValue,
      });
    }
  });
  console.log("filters", filters);

  return filters;
}

// Set up event listeners on DOMContentLoaded
document.addEventListener("DOMContentLoaded", function () {
  restoreFilters();

  // Attach event listeners to all filter-close buttons
  document.querySelectorAll(".qld__tag--filter-close").forEach((button) => {
    button.addEventListener("click", handleFilterClose);
  });
});
